import { apiService } from './api'


class AnimalTypeService {
  async getAnimalTypes(params?: any) {
    const response = await apiService.api.get('/admin/animal-types', { params })
    return response.data
  }

  async getAllAnimalTypes() {
    const response = await apiService.api.get('/admin/animal-types/all?include=breeds')
    return response.data
  }

  async getAnimalType(id: number | string) {
    const response = await apiService.api.get(`/admin/animal-types/${id}`)
    return response.data
  }

  async createAnimalType(data: any) {
    const response = await apiService.api.post('/admin/animal-types', data)
    return response.data
  }

  async updateAnimalType(id: number | string, data: any) {
    const response = await apiService.api.put(`/admin/animal-types/${id}`, data)
    return response.data
  }

  async deleteAnimalType(id: number | string) {
    await apiService.api.delete(`/admin/animal-types/${id}`)
  }

  async getAnimalTypeStats() {
    const response = await apiService.api.get('/admin/animal-types/stats')
    return response.data
  }
}

export const animalTypeService = new AnimalTypeService()
export default animalTypeService
